import styled from 'styled-components';
import { Autocomplete } from '@attain-sre/attain-design-system';

export const SearchArea = styled.div`
  position: sticky;
  top: 64px;
  z-index: 999;
  background: white;
  padding: 16px;
  border-bottom: 1px solid rgb(205, 199, 209);

  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;

  > * {
    flex-shrink: 0;
  }
`;

export const SelectAutoCompletePlatform = styled(Autocomplete)`
  width: 170px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const SelectAutoCompleteGroupOptions = styled.li`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  word-break: break-all;
`;

export const ClientName = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: start;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
`;

export const Description = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: start;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Platform = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: start;
  text-transform: capitalize;
`;

export const AdvertiserId = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: start;
`;

export const CreatedBy = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: start;
`;

export const CreatedAt = styled.div`
  font-size: 14px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const OAuthUrlCell = styled.div`
  display: flex;
  gap: 0px;
  align-items: center;
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
`;

export const OAuthUrlText = styled.div`
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SearchTextField = styled.div`
  width: 300px;
`;

export const MultiSelectWrapper = styled.div`
  flex-shrink: 0;
  width: 225px;
`;

export const SelectAutoCompleteEmail = styled(Autocomplete)`
  width: 225px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const CredentialGeneratedAt = styled.div`
  font-size: 14px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;
